import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getMe, getContactSettings, saveContactSettings } from "../lib/api";

// Does a contact someone types in wait for approval? Off by default; admins can turn it on.
export default function ContactSettings() {
  const [me, setMe] = useState(null);
  const [needs, setNeeds] = useState(false);
  useEffect(() => { Promise.all([getMe().then(setMe), getContactSettings().then(r => setNeeds(r.manual_requires_approval))]).catch(() => {}); }, []);
  if (!me) return null;
  const change = async (v) => {
    try { setNeeds((await saveContactSettings({ manual_requires_approval: v })).manual_requires_approval); toast.success("Saved"); }
    catch (e) { toast.error("Could not save"); }
  };
  return <fieldset className="key-group" data-testid="settings-contacts">
    <legend>Contacts you add by hand</legend>
    <label className="check-inline"><input type="checkbox" checked={needs} disabled={me.role !== "admin"} onChange={e => change(e.target.checked)} data-testid="manual-needs-approval" /> New contacts need approval before a sequence runs</label>
    <p>{needs ? "Contacts you add are held under Needs approval, like imported ones." : "Contacts you add are approved straight away and can start a sequence."} Imports and AI-call contacts always wait for approval.{me.role !== "admin" && " Only admins can change this."}</p>
  </fieldset>;
}
